var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{class:[_vm.theme, _vm.align],attrs:{"img-src":_vm.imgSrc,"img-alt":_vm.imgAlt,"img-left":""}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }